<template>
    <ticket-packages-resume-bar
        v-if="showResumeBar && isLogged && userData.total"
        :items="userData.items"
        :total="userData.total"
        :currency="userData.currency"
        :href="cartHref"
        :trans="trans"
    />
</template>

<script>
// Replica o padrão do riocarnaval-org-laravel (components/header/TopNavBar.vue):
// busca o resumo do carrinho e escuta o eventBus para reagir ao "Add to cart"
// sem precisar de reload. Montado fora da #app (header/topbar ou partial de
// tickets) porque no SBL a árvore principal do Vue é só o bloco de pacotes.
export default {
    props: {
        showResumeBar: {
            type: Boolean,
            default: false
        },
        trans: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isLogged: false,
            userData: {
                items: 0,
                total: "",
                currency: ""
            }
        };
    },
    computed: {
        cartHref() {
            const shopUrl = (window.bookersShopUrl || "").replace(/\/?$/, "/");
            if (!shopUrl) return "";
            return `${shopUrl}cart`;
        }
    },
    mounted() {
        this.fetchEndpointWithToken();

        window.eventBus.$on(
            "fetch-endpoint-with-token",
            this.fetchEndpointWithToken
        );
    },
    beforeDestroy() {
        window.eventBus.$off(
            "fetch-endpoint-with-token",
            this.fetchEndpointWithToken
        );
    },
    methods: {
        fetchEndpointWithToken() {
            const token = this.getToken();

            if (!token) {
                this.isLogged = false;
                return;
            }

            this.getCartResume(token)
                .then(data => {
                    this.isLogged = true;
                    this.userData = {
                        items: data.cart,
                        total: data.total,
                        currency: data.currency
                    };
                })
                .catch(e => {
                    console.error("Erro ao buscar resumo do carrinho:", e);
                    this.isLogged = false;
                });
        },

        getToken() {
            const queryParams = new URLSearchParams(window.location.search);

            if (queryParams.has("token")) {
                const token = queryParams.get("token");
                localStorage.setItem("token", token);
                return token;
            }

            return localStorage.getItem("token");
        },

        shopV2ApiUrl() {
            return (window.shopV2ApiUrl || "").replace(/\/?$/, "/");
        },

        getCartResume(token) {
            return new Promise((resolve, reject) => {
                if (!token) {
                    reject(new Error("missing_token"));
                    return;
                }

                const apiUrl = this.shopV2ApiUrl();

                if (!apiUrl) {
                    reject(new Error("missing_shop_v2_api_url"));
                    return;
                }

                const headers = {
                    Authorization: `Bearer ${token}`,
                    "X-Currency": (
                        window.shopCartCurrency || "USD"
                    ).toUpperCase(),
                    Accept: "application/json"
                };

                fetch(`${apiUrl}cart/resume`, {
                    method: "GET",
                    headers
                })
                    .then(async res => {
                        if (!res.ok) {
                            throw new Error("Erro ao fazer a chamada.");
                        }
                        const resume = await res.json();
                        resolve({
                            cart: resume.cart_items || 0,
                            total: resume.cart_amount || 0,
                            currency:
                                resume.currency ||
                                (window.shopCartCurrency || "USD")
                        });
                    })
                    .catch(reject);
            });
        }
    }
};
</script>
